module.exports = __webpack_public_path__ + "img/tmx-email-header.d7055622.jpg";